import { createApp } from 'vue'
import ShutdownPage from './components/ShutdownPage.vue'

import "./assets/scss/Main.scss";

// Element Plus Dark Mode Overrides
import "./style.css";

/**
 * Egolio has been shut down.
 * This displays a static shutdown page to all visitors.
 */
function initializeShutdownPage() {
    // Set document title
    document.title = 'Egolio - Goodbye';
    
    // Create minimal app with only shutdown page
    const shutdownApp = createApp(ShutdownPage);
    shutdownApp.mount('#app');
}

// Show shutdown page
initializeShutdownPage();

